import React, { Component, lazy, Suspense, useState } from "react";
import ReactDOM from "react-dom/client";
import * as Moment from "moment";
import * as Zustand from "zustand";
import Cropper from 'react-easy-crop';
import Webcam from 'react-webcam';
import MomentTZ from "moment-timezone";
import timezoneData from "moment-timezone/data/packed/latest.json";
import * as PopupDialog from "sweetalert2";

// Explicitly load timezone data
MomentTZ.tz.load(timezoneData);
import * as ReactStrap from "reactstrap";
// import * as Antd from "antd";
// import * as AntdIcons from "@ant-design/icons";
import * as ReactBootstrap from "react-bootstrap";
import * as KendoFileUploader from "@progress/kendo-react-upload";
import * as KendoReactButtons from "@progress/kendo-react-buttons";
import * as KendoReactDropDowns from "@progress/kendo-react-dropdowns";
import * as KendoReactDateInputs from "@progress/kendo-react-dateinputs";
import * as KendoReactPopup from "@progress/kendo-react-popup";
import * as KendoReactLayout from "@progress/kendo-react-layout";
import * as KendoReactCommon from "@progress/kendo-react-common";
import * as KendoDataQuery from "@progress/kendo-data-query";
import * as KendoReactWindow from "@progress/kendo-react-dialogs";
import * as Window from "@progress/kendo-react-dialogs";
import * as KendoReactGrid from "@progress/kendo-react-grid";
import * as KendoReactTreeView from "@progress/kendo-react-treeview";
import * as KendoReactInput from "@progress/kendo-react-inputs";
import * as KendoReactLabels from "@progress/kendo-react-labels";
import * as Input from "@progress/kendo-react-inputs";
import * as Ripple from "@progress/kendo-react-ripple";
import * as orderBy from "@progress/kendo-data-query";
import * as KendoLoader from "@progress/kendo-react-indicators";
import * as KendoReactDataTools from "@progress/kendo-react-data-tools";
import * as ReactMentions from "react-mentions";
import * as ReactBeautifulDnd from "react-beautiful-dnd";
import JsxParser from "react-jsx-parser";
import Editor from "./src/components/App/Editor.js"
import UploadArtifact from "./src/components/UploadArtifact.js";
import Components from "./src/components/StylesGuide";
import EOXApplication from "./src/EOXApplication.tsx";
import LeftMenuTemplate from "./src/LeftMenuTemplate";
import Notification from "./src/Notification.tsx";
import DateComponent from "./src/components/DateComponent.js";
import countryStateList from "./src/components/data/country-state-codes";
import OX_Grid from "./src/components/Grid/OX_Grid.jsx";
import DashboardManager from "./src/components/OI/DashboardManager";
import Dashboard from "./src/components/OI/Dashboard";
import DataSource from "./src/components/OI/DataSource";
import Query from "./src/components/OI/Query";
import PageContent from "./src/components/App/PageContent";
import DashboardFilter from "./src/components/OI/DashboardFilter";
// Lazy load WidgetRenderer to avoid loading 360MB of @amcharts on initial load
const WidgetRenderer = React.lazy(() => import("./src/components/OI/WidgetRenderer"));
// import DocumentList from "./src/DocumentList";
import Visualization from "./src/components/OI/Visualization";
import WidgetManager from "./src/components/OI/WidgetManager";
import TemplateManager from "./src/components/OI/TemplateManager";
import SSOCustom from "./src/components/Custom/SSOCustom";
import EOXGrid from "./src/components/EOXGrid/EOXGrid";
import ChildEOXGrid from "./src/components/EOXGrid/ChildEOXGrid.tsx";
import Helpers, { PopupContext, Tabs } from "./src/helpers";
import * as ModalPopup from "./src/components/modal-popups";
import * as FormIoReact from "./src/components/formio-react";
import { Formio } from "formiojs"; //remove if this causes merge issues when merging registration page changes
import JavascriptLoader from "./src/components/javascriptLoader";
import { ckeditorConfig } from "./src/components/OI/CkEditorConfig";
import Utils from "./src/helpers/utils";
import SideNavigation from "./src/SideNavigation.jsx";
import * as SideNav from "@trendmicro/react-sidenav";
import HeaderComponent from "./src/components/App/EntityViewer/header.js";
import FilterBuilder from './src/components/FilterBuilder'

import "./index.scss";

const LazyLoad = ({ component: Component, ...rest }) => (
  <React.Suspense
    fallback={
      <div className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    }
  >
    <Component {...rest} />
  </React.Suspense>
);

const FormRender = (props) => <LazyLoad component={lazy(() => import("./src/components/App/FormRender"))} {...props} />;
const FormBuilder = (props) => <LazyLoad component={lazy(() => import("./src/components/App/FormBuilder"))} {...props} />;
const MultiSelect = (props) => <LazyLoad component={lazy(() => import("./src/MultiSelect"))} {...props} />;
const HTMLViewer = (props) => <LazyLoad component={lazy(() => import("./src/components/App/HTMLViewer"))} {...props} />;
const CommentsView = (props) => <LazyLoad component={lazy(() => import("./src/components/App/CommentsView"))} {...props} />;
const DocumentViewer = (props) => <LazyLoad component={lazy(() => import("./src/DocumentViewer"))} {...props} />;
const DateFormats = (props) => <LazyLoad component={lazy(() => import("./src/public/js/DateFormats.js"))} {...props} />;
const DropDown = (props) => <LazyLoad component={lazy(() => import("./src/components/Dropdown/DropDownList"))} {...props} />;

export {
  EOXApplication,
  LeftMenuTemplate,
  Notification,
  MultiSelect,
  HTMLViewer,
  CommentsView,
  FormRender,
  OX_Grid,
  ChildEOXGrid,
  DocumentViewer,
  DashboardManager,
  Dashboard,
  WidgetRenderer,
  DataSource,
  Query,
  DashboardFilter,
  React,
  useState,
  PageContent,
  ReactDOM,
  DateFormats,
  ReactStrap,
  ReactBootstrap,
  KendoFileUploader,
  KendoReactDateInputs,
  KendoReactPopup,
  KendoReactDropDowns,
  KendoReactLayout,
  KendoDataQuery,
  KendoReactButtons,
  KendoReactWindow,
  KendoReactGrid,
  KendoReactInput,
  KendoReactDataTools,
  KendoLoader,
  Window,
  orderBy,
  Input,
  KendoReactLabels,
  Ripple,
  PopupDialog,
  Moment,
  MomentTZ,
  DateComponent,
  DropDown,
  countryStateList,
  FormBuilder,
  Suspense,
  Visualization,
  WidgetManager,
  // Antd,
  // AntdIcons,
  TemplateManager,
  SSOCustom,
  EOXGrid,
  Helpers,
  ModalPopup,
  FormIoReact,
  Formio,
  PopupContext,
  Tabs,
  JavascriptLoader,
  ckeditorConfig,
  Utils,
  Component,
  ReactMentions,
  Components,
  ReactBeautifulDnd,
  JsxParser,
  SideNav,
  UploadArtifact,
  HeaderComponent,
  KendoReactCommon,
  KendoReactTreeView,
  Editor,
  SideNavigation,
  Zustand,
  Cropper,
  Webcam,
  FilterBuilder
};